/* eslint-disable */

import * as SchemaTypes from '@freelancerepublik/graphql-types';

import { gql } from '@apollo/client/core';
export type UserNotifiedSubscriptionVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type UserNotifiedSubscription = { __typename?: 'Subscription', userNotified: { __typename?: 'UserNotification', id: string, status: SchemaTypes.NotificationStatusEnum, message: string } };


export const UserNotifiedDocument = gql`
    subscription userNotified {
  userNotified {
    id
    status
    message
  }
}
    `;

